import {Component, EventEmitter, Injectable, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {NgIf, NgStyle} from "@angular/common";
import {ScrollService} from "../../../services/scroll-service";
import {IconComponent} from "../icon/icon.component";
import {Icons} from "../../../model/icon";
import {getImageUrl} from "../../../functions/getImageUrl";
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-full-screen-slider',
  imports: [
    NgStyle,
    IconComponent,
    NgIf
  ],
  templateUrl: './full-screen-slider.component.html',
  styleUrl: './full-screen-slider.component.scss'
})
export class FullScreenSliderComponent implements OnChanges{

  @Input() active: boolean = false;
  @Input() photo: string = '/app/assets/hero/hero1.png';
  @Input() count: number | undefined;
  @Output() activeEmit = new EventEmitter();
  @Output() clickLeftEmit = new EventEmitter();
  @Output() clickRightEmit = new EventEmitter();

  constructor(private scrollService: ScrollService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.active) {
      this.scrollService.lockScroll();
    } else {
      this.scrollService.unlockScroll();
    }
  }

  activate(event: any) {
    this.active = !this.active;
    if (this.active) {
      this.scrollService.lockScroll();
    } else {
      this.scrollService.unlockScroll();
    }
    this.activeEmit.emit(this.active);
  }

  clickLeft(event: any) {
    event.stopPropagation();
    this.clickLeftEmit.emit()
  }

  clickRight(event: any) {
    event.stopPropagation();
    this.clickLeftEmit.emit()
  }

  isArrow() {
    return this.count != undefined && this.count > 1;
  }

  scale = 1;
  lastScale = 1;
  isDragging = false;
  lastX = 0;
  lastY = 0;
  translateX = 0;
  translateY = 0;

  get transformStyle() {
    return `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`; // Увеличение изображения
  }

  clickPhoto(event: any) {
    event.preventDefault(); // Предотвращает действие по умолчанию
    event.stopPropagation(); // Останавливает всплытие события
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.lastX = event.clientX;
    this.lastY = event.clientY;
    // Отключаем текстовое выделение
    event.preventDefault();
  }

  onWheel(event: any, value?: number) {
    event.preventDefault();
    event.stopPropagation();
    if (value) {
      this.scale += value;
    } else {
      const scaleChange = event.deltaY > 0 ? -0.1 : 0.1; // Уменьшение или увеличение
      this.scale += scaleChange;
    }
    this.scale = Math.min(Math.max(this.scale, 1), 3); // Ограничиваем масштаб от 1 до 3
    this.lastScale = this.scale; // Сохраняем последний масштаб
  }

  onMouseUp() {
    this.isDragging = false;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;

    const deltaX = event.clientX - this.lastX;
    const deltaY = event.clientY - this.lastY;

    this.translateX += deltaX;
    this.translateY += deltaY;

    this.lastX = event.clientX;
    this.lastY = event.clientY;

    requestAnimationFrame(() => {
      this.transformStyle;
    });
  }

  protected readonly event = event;
  protected readonly Icons = Icons;
  protected readonly getImageUrl = getImageUrl;
}
